<template>
  <div class="ui grid container">
    <!-- <inventory-distribution class="sixteen wide column" /> -->
    <inventory-overview class="sixteen wide column" style="margin-bottom:0" />
    <inventory-input class="eight wide column" />
    <inventory-output class="eight wide column" />
  </div>
</template>

<script>
import filters from "@/filters";
import InventoryInput from "./input/InventoryInputComponent";
import InventoryOutput from "./output/InventoryOutputComponent";
// import InventoryDistribution from "./distribution/InventoryDistributionComponent";
import InventoryOverview from "./overview/InventoryOverviewComponent";

// @ is an aliass to /src
export default {
  name: "InventoryIndex",
  components: {
    InventoryInput,
    InventoryOutput,
    // InventoryDistribution,
    InventoryOverview
  },
  filters: filters,
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>
